<template>
    <div>
        <div class="tile is-ancestor">
            <div class="tile has-text-left is-12 is-vertical is-parent">
                <div class="tile is-child box">
                    <div class="columns is-mobile">
                        <div class="column is-one-third"><strong>Name: </strong></div>
                        <div class="column">{{currentValidationPlanTemplate.name}}</div> 
                    </div>
                    <div class="columns is-mobile">
                        <div class="column is-one-third"><strong>Guideline:</strong></div>
                        <div class="column ">{{currentValidationPlanTemplate.guideline}}</div> 
                    </div>
                    <div class="columns is-mobile">
                        <div class="column is-one-third"><strong>Comment:</strong></div>
                        <div class="column ">{{currentValidationPlanTemplate.comment}}</div>   
                    </div>
                    <div class="columns is-mobile">
                        <div class="column is-one-third"><strong>Status:</strong></div>
                        <div class="column">{{currentValidationPlanTemplate.status}}</div>  
                    </div>
                    <div class="columns is-mobile">
                        <div class="column is-one-third"><strong>Created on:</strong></div>
                        <div class="column">{{moment(currentValidationPlanTemplate.created_at).format("DD MMMM YYYY")}}</div>  
                    </div>
                </div>

                <!-- Validation Parameters Start -->
                <div class="tile is-child box">
                    <p class="subtitle is-4">Validation Parameters</p>

                    <div v-for="valParam in valParamSet" :key="valParam">
                        <a class="button accordionButton is-large is-fullwidth" style="margin-top:20px" :id="valParam" v-on:click="accordionAction(valParam)">
                            <span>
                                {{valParam}}
                            </span>
                            <span class="icon is-small is-pulled-right">
                                <i class="fas fa-caret-down"></i>
                            </span>
                        </a>
                        <div class="tile is-ancestor contentOfAccordion">
                            <div class="tile is-parent">
                                <div class="tile is-child box">
                                    <div class="content">
                                        <!-- Heading of Validation Parameter -->
                                        <div class="columns is-mobile">
                                            <div class="column is-two-fifths">
                                                <strong>Method of Assessment</strong>
                                            </div>
                                            <div class="column">
                                                <strong>Criteria</strong>
                                            </div>
                                        </div>
                                        <!-- / -->

                                        <!-- content of Validation Parameter -->
                                        <div v-for="assesmentMethod in assesmentMethods" :key="assesmentMethod.id" v-if="assesmentMethod.validation_parameter_display == valParam">
                                            <hr>
                                            <div class="columns is-mobile">
                                                <div class="column is-two-fifths">
                                                    <!-- method of ass -->
                                                    {{assesmentMethod.name}}
                                                </div>
                                                <div class="column">
                                                    <!-- criteria and value -->
                                                    <div v-for="assesmentMethodCriteria in assesmentMethod.criteria" :key="assesmentMethodCriteria.id">
                                                        <div class="columns">
                                                            <div class="column">
                                                                <strong>{{assesmentMethodCriteria.name}} :</strong>
                                                            </div>

                                                            <div class="column has-text-left">
                                                                {{assesmentMethodCriteria.value}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                          <div v-if="assesmentMethod.metadatas && assesmentMethod.metadatas.length">
                                            <p class="is-size-9 has-text-weight-bold">Parameters</p>
                                            <metadata-component :metadata-list="assesmentMethod.metadatas" :editable="false"></metadata-component>
                                          </div>
                                        </div>
                                        <!-- / -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <!-- Validation Parameters end -->      
            </div>
        </div>
    </div>
</template>


<script>
import PageTitleDisplay from "@/components/features/displayElements/PageTitleDisplay";

var moment = require('moment');
import { mapGetters } from 'vuex'
import MetadataComponent from "@/valchrom/common/metadata/MetadataComponent";
export default {
    name: "ViewValidationPlanTemplateComponent",
    props: ["currentValidationPlanTemplate", "assesmentMethods", "validationParameters"],
    components: {PageTitleDisplay,MetadataComponent},

    computed: {
        ...mapGetters ([
            'base_url'
        ]),
        // TODO
        valParamSet: function(){   
            var valParamSet = new Set()    
            this.assesmentMethods.forEach(function(method) {
                valParamSet.add(method.validation_parameter_display)
            })
            var arr = Array.from(valParamSet)
            return arr.sort((a, b) => {return this.validationParameters.indexOf(a) - this.validationParameters.indexOf(b)})
        },
    },

    data: function() {
        return {
            moment:moment,
            isEmpty: false,
            isLoading: false,
            isOpenActive: true,
            isOpenArchived: false,
        }
    },
    methods : {
        editValidationPlanTemplate: function (currentValidationPlanTemplate) {
            console.log("ValidationPlanTemplate edit btn in view clicked for: ", currentValidationPlanTemplate.name)
            this.$emit("editValidationPlanTemplate", currentValidationPlanTemplate);
        },
        back: function() {
            this.$emit("back");
        },
        accordionAction: function(id) {
            var accordionButton = document.getElementById(id)
            var contentOfAccordion = document.getElementById(id).nextSibling
            // console.log("x.style.display", x) is-primary 
            if (contentOfAccordion.style.display == "block") {
                contentOfAccordion.style.display = "none"
                accordionButton.classList.remove("is-primary");
            } else if (contentOfAccordion.style.display == "none") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            } else if(contentOfAccordion.style.display == "") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            }

            // accordionButton class
            var otherAccordions = Array.from(document.getElementsByClassName("accordionButton"))
            // console.log("ohters...", otherAccordions)    
            otherAccordions.forEach(function(otherAccordionButton){
                if(accordionButton != otherAccordionButton){
                    var content = otherAccordionButton.nextSibling
                    content.style.display = "none"
                    otherAccordionButton.classList.remove("is-primary");
                }
                
            })
        }     
    }
}
</script>

<style scoped>
.contentOfAccordion{
    display: none;
}
</style>
